module.exports = __webpack_public_path__ + "static/media/sap.a1afe98b.png";